module.exports = __webpack_public_path__ + "img/23_storm.a3475812.jpg";